/** Turns monday's daily-limit error into a plain message; otherwise returns the fallback. */
export function friendlyError(e: unknown, fallback: string): string {
  const s = String((e as { message?: string })?.message ?? e);
  if (s.includes('DAILY_LIMIT')) return 'monday.com\'s daily request limit has been reached for your account. This page will work again once it resets (usually within a day).';
  return fallback;
}
